<template>
  <b-container fluid>
    <div v-if="visnetHub" class="">
      <Breadcrumbs :project="project" :substation="substation" :visnet-hub="visnetHub" />
      <loader watch="substationVisnetHub">
        <b-row>
          <b-col md="3" lg="3" xl="2">
            <InfoSection :visnet-hub="visnetHub" />
          </b-col>
          <b-col md="9" lg="9" xl="10">
            <router-view />
          </b-col>
        </b-row>
      </loader>
    </div>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';
import Breadcrumbs from '@/components/shared/breadcrumbs';
import InfoSection from '@/components/substations/visnet-hubs/landing-visnet-hub-info';

const STORE_MODULES_CLEAR_MUTATION = [
  'electricalData/resetStore',
  'environmentalData/resetStore',
  'powerQualityData/resetStore',
  'substationVisnetHub/resetStore',
  'visnetHubFaultPanelData/resetStore',
  'visnetHubFaultWaveforms/resetStore',
  'visnetHubFaultElectricalData/resetStore',
  'visnetHubFaultElectricalDataImpedance/resetStore',
  'visnetHubFaultEvents/resetStore'
];

export default {
  name: 'SubstationVisnetHub',
  components: {
    Breadcrumbs,
    InfoSection
  },
  props: {
    projectCode: String,
    substationCode: String,
    externalVisnetHubId: String
  },
  computed: mapState({
    visnetHub: state => state.substationVisnetHub.visnetHub,
    substation: state => state.substationVisnetHub.visnetHub.substation,
    project: state => state.substationVisnetHub.visnetHub.substation.project,
    activeView: state => state.substationVisnetHub.activeView
  }),
  mounted() {
    const visnetParams = {
      projectCode: this.projectCode,
      substationCode: this.substationCode,
      externalVisnetHubId: this.externalVisnetHubId
    };
    this.$store.dispatch('substationVisnetHub/fetchData', visnetParams);
  },
  destroyed() {
    STORE_MODULES_CLEAR_MUTATION.forEach(storeModuleReset => {
      this.$store.commit(storeModuleReset);
    });
  }
};
</script>
